import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { getOAuthUrls } from './util/oauth.js';
import { isSameRefreshToken } from './util/refreshToken.js';
import { handleOAuthResponse } from './handleOAuthResponse.js';
import { postRefreshToken } from './endpoints/token.js';
import { findKeyPair } from './dpop.js';
import { isRefreshTokenInvalidError } from './util/errors.js';
function renewTokensWithRefresh(_x, _x2, _x3) {
  return _renewTokensWithRefresh.apply(this, arguments);
}
function _renewTokensWithRefresh() {
  _renewTokensWithRefresh = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, tokenParams, refreshTokenObject) {
    var _sdk$options, clientId, dpop, renewTokenParams, endpointParams, keyPair, tokenResponse, urls, _yield$handleOAuthRes, tokens, refreshToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _sdk$options = sdk.options, clientId = _sdk$options.clientId, dpop = _sdk$options.dpop;
          if (clientId) {
            _context.next = 3;
            break;
          }
          throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to renew tokens');
        case 3:
          _context.prev = 3;
          renewTokenParams = Object.assign({}, tokenParams, {
            clientId: clientId
          });
          if (refreshTokenObject.extraParams) {
            renewTokenParams.extraParams = refreshTokenObject.extraParams;
          }
          endpointParams = Object.assign({}, renewTokenParams);
          if (!dpop) {
            _context.next = 14;
            break;
          }
          _context.next = 10;
          return findKeyPair(refreshTokenObject === null || refreshTokenObject === void 0 ? void 0 : refreshTokenObject.dpopPairId);
        case 10:
          keyPair = _context.sent;
          endpointParams.dpopKeyPair = keyPair;
          renewTokenParams.dpop = dpop;
          renewTokenParams.dpopPairId = refreshTokenObject.dpopPairId;
        case 14:
          _context.next = 16;
          return postRefreshToken(sdk, endpointParams, refreshTokenObject);
        case 16:
          tokenResponse = _context.sent;
          urls = getOAuthUrls(sdk, tokenParams);
          _context.next = 20;
          return handleOAuthResponse(sdk, renewTokenParams, tokenResponse, urls);
        case 20:
          _yield$handleOAuthRes = _context.sent;
          tokens = _yield$handleOAuthRes.tokens;
          refreshToken = tokens.refreshToken;
          if (refreshToken && !isSameRefreshToken(refreshToken, refreshTokenObject)) {
            sdk.tokenManager.updateRefreshToken(refreshToken);
          }
          return _context.abrupt("return", tokens);
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](3);
          if (isRefreshTokenInvalidError(_context.t0)) {
            sdk.tokenManager.removeRefreshToken();
          }
          throw _context.t0;
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 27]]);
  }));
  return _renewTokensWithRefresh.apply(this, arguments);
}
export { renewTokensWithRefresh };